import { makeStyles } from "@material-ui/core";
import React from "react";
import Autocomplete from "react-google-autocomplete";

const useStyles = makeStyles(() => ({
  filterAutoComplete: {
    backgroundColor: "#f3f6f9",
    marginBottom: "8px",
    padding: "10px 10px !important",
  },
}));

const AddressAutoComplete = ({
  address,
  onChange,
  setPlace,
  types = ["address"],
  autoComId,
  labelRequired = true,
  placeholder = "Enter a location",
  label = "Address",
  isRequired = false,
}) => {
  const classes = useStyles();

  const val = address === true ? "" : address;

  return (
    <div className={`inputWrapper autoCompleteAddressWrapper`}>
      {labelRequired && <label className='envAutoLocLable'>{label}</label>}
      <Autocomplete
        className={`autocomplete${
          !labelRequired ? ` ${classes.filterAutoComplete}` : ""
        }`}
        style={{ borderColor: isRequired ? "red" : "" }}
        placeholder={placeholder}
        id={autoComId}
        apiKey={"AIzaSyDJ3I1GNJkB4YhqogpYWDWcEh4vR1yc9P8"}
        options={{
          types,
        }}
        onPlaceSelected={place => {
          setPlace(place);
        }}
        onChange={onChange}
        // defaultValue={val}
        value={val}
      />
      {isRequired ? (
        <div>
          <p
            style={{
              color: "red",
              fontSize: "0.64rem",
              margin: "8px",
            }}>
            This field is required
          </p>
        </div>
      ) : null}
    </div>
  );
};

export { AddressAutoComplete };
